import React, { useState, useEffect } from 'react';
import { Encriptar, Validaciones } from '@renedelangel/helpers';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import './Style.css';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';
import Boton from './Boton'
import Close from "@material-ui/icons/Close";
import Mail from '@material-ui/icons/Mail';
import SaveIcon from '@material-ui/icons/Save';
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';
import * as Consultas from '../Encuesta/Consultas.js'
import SeccionI from './SeccionI';
import SeccionIV from './SeccionIV';
import SeccionV from './SeccionV';
import SeccionVII from './SeccionVII';
import SeccionVIII from './SeccionVIII';
import SeccionIX from './SeccionIX';
import SeccionX from './SeccionX';
import SeccionXI from './SeccionXI';
import SeccionXII from './SeccionXII';
import SeccionXIII from './SeccionXIII';
import SeccionXIV from './SeccionXIV';
import SeccionFirmas from './SeccionFirmas';
import SeccionDinamica, { leerEstructura, preguntasSinContestar, clasificacionAdjunto } from './SeccionDinamica';
import { getFile } from '../../../mutations/ServerStorage';

import { actualizaArchivo } from "../../../helpers/serverStorage";
import * as ConsultasDominios from '../../../querys/Dominios';

import { danger, success } from '../../../_layout/helpers/colores';

import { handleAlertGeneric, handleAlertMutationGeneric } from '_layout/helpers/handles';
import { urlServidor } from 'helpers';

const { Decrypt } = Encriptar;
function PlantillaEncuesta({info = null, objProps = {}, openFromEncuesta = false, agregarFirmas = false,handleCloseVerPreguntas}) {
  let { token } = useParams();
  let tokenFijo = 'c29mdHdvbmUyMDIwQCM='
  let url = "";

  const { trim } = Validaciones;

  let seed = "segumex";
  if (token && !openFromEncuesta) {
    url = token.replace(/&/g, "/");
    objProps = Decrypt({ data: url, seed }) !== "" ? JSON.parse(Decrypt({ data: url, seed })) : null;
    info = { token: token }
  } else if(openFromEncuesta){
    objProps = info;
    token = info.token;
  }

  if(agregarFirmas){
    openFromEncuesta = false
  }
  const cleanState = {
    correo: "",
    dominio: "",
    accion:""
};
  const [alert, setAlert] = useState(null);
  const [errorState, setErrorState] = useState(false);
  const [stSeccionesVisibles, setSeccionesVisibles] = useState([]);
  const [stSecciones, setSecciones] = useState([]);
  const [stDisabled, setDisabled] = useState(false);
  const [stateContestada, setContestada] = useState(false);
  const [actualizar, setActualizar] = useState(false);
  const [openEnviarCorreo, setOpenEnviarCorreo] = useState(false);
  const [seleccionables, setSeleccionables] = useState(false);
  const [state, setState] = useState(cleanState);


  let { encuestaID, seccionID, ejercicio, estatus = 'PENDIENTE' } = objProps;

  // Folio de la encuesta (viene en cada sección); el título lo muestra en lugar del ejercicio
  let primeraSeccion = Object.values(stSecciones)[0];
  let folioEncuesta = primeraSeccion ? primeraSeccion.folio : null;

  useEffect(() => {
    async function ftEffect() {
      try {
        
        let Dominios = await ConsultasDominios.seleccionDominios({}, token);
        setSeleccionables({ Dominios });

        if (seccionID) {
          let regSeccion = await Consultas.getEncuestaSecciones({ encuestaID, seccionID }, token);
          if (!regSeccion) {
            setErrorState(true);
            return;
          }
          let seccionesAux = {};
          seccionesAux[regSeccion.seccion] = regSeccion;
          setSecciones(seccionesAux);
          setSeccionesVisibles([regSeccion.seccion])
        } else {
          setDisabled(true);
          let regSecciones = await Consultas.getAllEncuestaSecciones({filtro: { encuestaID }}, token);
          regSecciones = [...regSecciones].sort((a, b) => Number(a.seccionID) - Number(b.seccionID));
          let seccionesAux = {};
          let seccionesCve = [];

          for (let i = 0; i < regSecciones.length; i++) {
            let regSeccion = regSecciones[i];
            seccionesCve.push(regSeccion.seccion);
            seccionesAux[regSeccion.seccion] = regSeccion;
          }

          setSecciones(seccionesAux);
          setSeccionesVisibles(seccionesCve);
        }
      } catch ({ message }) {
        setAlert({
          descripcion: message,
          title: "¡Una disculpa!",
          tipo: "danger",
          msjConfirmacion: "Aceptar",
          onConfirm: () => setAlert(null)
        });
        setErrorState(true);
      }
    } ftEffect();
  }, []);

  function handleRespuestaSeccion(seccion, respuesta) {
    let seccionesAux = stSecciones;
    seccionesAux[seccion].respuesta = respuesta;
    setSecciones(seccionesAux);
  }
  
  function handleAdjunto(seccion, adjunto) {
    let seccionesAux = stSecciones;
    seccionesAux[seccion].adjunto = adjunto;
    setSecciones(seccionesAux);
  }

  async function ftGuardarRespuestas(){

    if(agregarFirmas){
       handleAlertGeneric({
        setAlert,
        onCancel: () => setAlert(null),
        mensaje: {
            title: "Revision de Encuesta", descripcion: "¿Desea marcar como revisada la encuesta?", tipo: "warning", msjConfirmacion: "Aceptar", msjCancelacion: "Cancelar"
        },

        onConfirm: () =>  handleAlertMutationGeneric({
        token, setAlert, setActualizar, actualizar,
        parametros: {}, asyncMutation: () => ftGuardar(),
        mensajes: {
            msjEspera: {
                title: "Espere...", descripcion: "Se estan guardando las respuestas", tipo: success
            },
            msjCorrecto: {
                title: "Encuesta Contestada", descripcion: 'Se guardaron sus respuestas correctamente.', msjConfirmacion: "Aceptar"
                  }
              }
        })
      })
    }else{
      handleAlertMutationGeneric({
        token, setAlert, setActualizar, actualizar,
        parametros: {}, asyncMutation: () => ftGuardar(),
        mensajes: {
            msjEspera: {
                title: "Espere...", descripcion: "Se estan guardando las respuestas", tipo: success
            },
            msjCorrecto: {
                title: "Encuesta Contestada", descripcion: 'Se guardaron sus respuestas correctamente.', msjConfirmacion: "Aceptar"
                  }
              }
        })
    }
  }

  async function ftGuardar() {
    try {
        if(agregarFirmas){
          // Por encuesta y no por ejercicio: un ejercicio puede tener varias encuestas
          let {listado: datosEncuestaSecciones} = await Consultas.tablaEncuestaSecciones({filtro:{encuestaID: parseInt(encuestaID), count: null, pagina: 1, limite: 100}  }, token);

          for (let i = 0; i < datosEncuestaSecciones.length; i++) {
              if(datosEncuestaSecciones[i].seccion === "FIRMAS"){
                seccionID = parseInt(datosEncuestaSecciones[i].seccionID)
              }
            }
        }


      if (seccionID) {
        let sinContestar = stSeccionesVisibles.flatMap(clave => preguntasSinContestar(stSecciones[clave].estructura, stSecciones[clave].respuesta));
        if (sinContestar.length > 0) {
          throw new Error(`Faltan preguntas obligatorias por contestar: ${sinContestar.join(" | ")}`);
        }

        for (let i = 0; i < stSeccionesVisibles.length; i++) {

          let seccionAux = stSeccionesVisibles[i];

          // Secciones del catálogo: un adjunto por pregunta; si la pregunta ya tenía archivo se reemplaza
          if (stSecciones[seccionAux].adjunto && !Array.isArray(stSecciones[seccionAux].adjunto)) {
            let origenID = Number(stSecciones[seccionAux].seccionID);
            for (const [preguntaCatID, adjunto] of Object.entries(stSecciones[seccionAux].adjunto)) {
              let clasificacion = clasificacionAdjunto(preguntaCatID);
              let actual = await getFile({ origenID, tipo: 'ADJUNTO', clasificacion });
              let datos = {
                serverStorageID: actual ? actual.serverStorageID : null,
                origenID,
                tipo: "ADJUNTO",
                clasificacion,
                nombreArchivo: adjunto.name.split(".")[0],
                ruta: actual ? actual.ruta : `ENCUESTA/SECCION${seccionAux}/`,
                tabla: "ENCUESTA"
              };
              await actualizaArchivo(`ENCUESTA/SECCION${seccionAux}/`, adjunto, 1, datos, 'vacio');
            }
          } else if(stSecciones[seccionAux].adjunto != undefined) {

          let adjunto = stSecciones[seccionAux].adjunto[0];

          let name = adjunto.name.split(".")
          name = name[0]
          
          let datos = {
            serverStorageID: null,
            origenID: Number(stSecciones[seccionAux].seccionID),
            tipo: "ADJUNTO",
            clasificacion: "ADJUNTOSENCUESTA",
            nombreArchivo: name,
            ruta: `ENCUESTA/SECCION${seccionAux}/`,
            tabla: "ENCUESTA"
        }
          await actualizaArchivo(`ENCUESTA/SECCION${seccionAux}/`, adjunto, 1, datos, 'vacio');
      }

          await Consultas.actualizarRespuestas({ seccionID: stSecciones[seccionAux].seccionID, respuesta: stSecciones[seccionAux].respuesta, agregarFirmas });
          
        }
      }
      setContestada(true)
    } catch ({ message }) {
      setAlert({
        descripcion: message,
        title: "¡Una disculpa!",
        tipo: "danger",
        msjConfirmacion: "Aceptar",
        onConfirm: () => setAlert(null)
      });
      throw new Error(message);
    }
  }

  function AuxDescargar() {

    handleAlertGeneric({
        setAlert,
        onCancel: () => setAlert(null),
        mensaje: {
            title: "Generar PDF de encuesta", descripcion: "¿Deseas generar y descargar la encuesta?", tipo: "warning", msjConfirmacion: "Aceptar", msjCancelacion: "Cancelar"
        },

        onConfirm: () => handleAlertMutationGeneric({
            token, setAlert, setActualizar, actualizar,
            parametros: {}, asyncMutation: () => DescargarPdf(),
            mensajes: {
                msjEspera: {
                    title: "Espere...", descripcion: "Generando el formato de impresión de la seccion ", tipo: success
                },
                msjCorrecto: {
                    title: "Se generó con éxito", descripcion: 'Se descargó el formato de impresión de la seccion', msjConfirmacion: "Aceptar"
                }
            }
        })
    })
}
const showFile = (archivo, name = 'file.pdf',) => {
    let url = window.URL.createObjectURL(archivo);
    let a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
    a.remove();
};

async function DescargarPdf() {
    let myHeaders = new Headers();
    myHeaders.append("token", token);
    myHeaders.append("mimeType", "multipart/form-data");
    
    let correo = "";
    correo = state.correo+state.dominio


    let formdata = new FormData();
    formdata.append("estatus", estatus);
    formdata.append("correo", correo);
    formdata.append("ejercicio",info.ejercicio);
    formdata.append("encuestaID", info.encuestaID);
    formdata.append("accion", state.accion);

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    };

    await fetch(`${urlServidor}/service/reportes/ReporteEncuesta`, requestOptions)
        .then(response => {
            if (!response.ok) return response.json();
            return response.blob()
        })
        .then(result => {
            let { error, mensaje } = result;
            if (error) throw new Error(mensaje);
            if(state.accion !=="EnviarCorreo"){
              showFile(result, `Encuesta.pdf`);
            }
            setAlert(null)
        })
        .catch(({ message }) => { throw new Error(message) });
}

async function EnviarCorreo() {
  try {
      let validacorreo = state.correo.includes('@');
      if (trim(state.correo) === "" || validacorreo) throw new Error("Debe ingresar un correo valido");
      if (trim(state.dominio) === "") throw new Error("Debe ingresar un dominio");
      handleAlertMutationGeneric({
          token, setAlert, setActualizar, actualizar,
          parametros: {},
          asyncMutation: () => DescargarPdf(),
          mensajes: {
              msjEspera: {
                  title: `Espere por favor`,
                  descripcion: `Enviando encuesta...`
              },
              msjCorrecto: {
                  title: `Correcto`,
                  descripcion: `La encuesta se ha enviado`
              }
          }
      })
      setOpenEnviarCorreo(false)
  } catch ({ message }) {
      window.alert(message)
  }
}

const inputsEnviarCorreo = [
  {
      id: "correo",
      title: "Correo *",
      grid: { md: 6, lg: 6 },
      placeholder: "Capture el correo",
      onChange: ({ target: { value } }) => setState({ ...state, correo: value }),
  },
  {
      id: "dominio",
      title: "Dominio *",
      placeholder: "Seleccione el dominio",
      tipo: "select",
      data: seleccionables.Dominios,
      grid: { md: 6, lg: 6 },
      onChange: ({ target: { value } }) => setState({ ...state, dominio: value }),
  },
]

const accionesFormularioEnviarCorreo = [{
  accionID: "EnviarCorreo",
  icono: Mail,
  color: success,
  descripcion: "Enviar",
  onClick: () => EnviarCorreo()
}, {
  icono: Close,
  color: danger,
  descripcion: "Cancelar",
  onClick: () => setOpenEnviarCorreo(false)
}];

  function renderSeccion(clave) {
    let seccion = stSecciones[clave];
    let comunes = {
      key: clave,
      respuesta: seccion.respuesta,
      ejercicio,
      setRespuesta: (respuesta) => handleRespuestaSeccion(clave, respuesta),
      disabled: stDisabled
    };

    if (leerEstructura(seccion.estructura)) {
      return <SeccionDinamica {...comunes}
        estructura={seccion.estructura}
        seccionID={seccion.seccionID}
        setAdjunto={(adjunto) => handleAdjunto(clave, adjunto)} />;
    }

    switch (clave) {
      case "I": return <SeccionI {...comunes} />;
      case "IV": return <SeccionIV {...comunes} />;
      case "V": return <SeccionV {...comunes} />;
      case "VII": return <SeccionVII {...comunes} />;
      case "VIII": return <SeccionVIII {...comunes} />;
      case "IX": return <SeccionIX {...comunes} />;
      case "X": return <SeccionX {...comunes} />;
      case "XI": return <SeccionXI {...comunes} setAdjunto={(adjunto) => handleAdjunto("XI", adjunto)} seccionID={seccionID} />;
      case "XII": return <SeccionXII {...comunes} setAdjunto={(adjunto) => handleAdjunto("XII", adjunto)} seccionID={seccionID} />;
      case "XIII": return <SeccionXIII {...comunes} />;
      case "XIV": return <SeccionXIV {...comunes} />;
      case "FIRMAS": return <SeccionFirmas {...comunes} disabled={estatus === 'PENDIENTE' ? false : stDisabled} />;
      default: return <React.Fragment key={clave}></React.Fragment>;
    }
  }

  return (<>
    <div className="cContenedorEncuesta">
    {
      stateContestada ?
      <div className="cErrorEncuesta"> Encuesta contestada
        <br />Se guardaron sus respuestas correctamente.
      </div> : <>
      <div class="ListadoPreguntas" id='listadoEncuestasID'>
        <div class="Contenedor-Titulo">
          <div class="ContenedorLogoTitulo">
            <div class="Logo">
            </div>
            <div class="Titulo">
              {"Cuestionario de Responsabilidad Civil para Operadores de Terminales Portuarias (" + (folioEncuesta || ejercicio) + ")"}
            </div>
          </div>
        </div>
        {errorState ? <></> :
          <div className="cContenedorSeccion">
            <div className="cTituloInstruccioes">
             {agregarFirmas ? "Por favor responda las preguntas que sean pertinentes al apartado de firmas." : "Por favor responda las preguntas que sean pertinentes a la operación del solicitante. Si el mismo opera en más de una terminal, rogamos completar un cuestionario para cada una de ellas."}
            </div>
          </div>}
        {stSeccionesVisibles.map(clave => renderSeccion(clave))}
      </div>
      {
        errorState ?
          <div className="cErrorEncuesta">Ocurrió un problema al cargar la encuesta.
            <br />Esto puede deberse a que el link a caducado o la encuesta ya no está disponible.
            <br />Te pedimos amablemente una disculpa y de ser posible nos informes de este error
          </div> : <></>
      }
      {
        // !openFromEncuesta ?
        (errorState?
        <>
        </>:        
                <div className='cContenedorBotonesEncuesta'>
                  <div className='cContenedorBotonesEncuesta' style={{ display: 'flex', flexDirection: 'row' }}>
                    {
                      info.accion === 'RevisarEncuesta' &&
                      <Boton titulo={"Generar PDF"}
                        colorFondo="#388e3c"
                        colorletra="white"
                        onClick={() => { setState({ ...state, accion:"GenerarPDF" }); AuxDescargar()}} />
                    }
                    {
                      <Boton titulo={"Guardar respuesta"}
                        colorFondo="var(--colorInfo)"
                        colorletra="white"
                        onClick={() => ftGuardarRespuestas()} />
                    }
                    {
                      info.accion === "RevisarEncuesta" && <Boton titulo={"Enviar por correo"}
                        colorFondo="#0D3C61"
                        colorletra="white"
                        onClick={() => { setOpenEnviarCorreo(true); setState({ ...state, accion:"EnviarCorreo" }) }}
                      />
                    }
                     {
                      info.accion === 'RevisarEncuesta' &&
                      <Boton titulo={"Cancelar"}
                        colorFondo="#F31818"
                        colorletra="white"
                        onClick={() => { handleCloseVerPreguntas()}} />
                    }
                  </div>
                </div>
        )
      } 
      </>
      }
      {openEnviarCorreo && <FormularioModal
                open={openEnviarCorreo}
                title={"Enviar por correo"}
                onClose={() => setOpenEnviarCorreo(false)}
                inputs={inputsEnviarCorreo}
                acciones={accionesFormularioEnviarCorreo}
            />
        } 
      {alert &&
        <SweetAlert
          title={alert.title}
          descripcion={alert.descripcion}
          tipo={alert.tipo}
          msjConfirmacion={alert.msjConfirmacion}
          msjCancelacion={alert.msjCancelacion}
          onConfirm={alert.onConfirm}
          showConfirm={alert.showConfirm}
          showCancel={alert.showCancel}
          onCancel={() => setAlert(null)}
        />
      }
    </div>
  </>);
}
export default PlantillaEncuesta;